<template>
  <div class="unvocalized-scan" :class="{'mobile-results':mobile}">
    <div class="unvocalized-search-wrap mb-2" v-if="!mobile">
      <div class="container">
        <MainSearch class="col-lg-8 m-auto py-3"/>  
      </div>  
    </div>
    <div class="container" :class="{'invisible':commonCount == 0}">
      <div v-if="mobile"><NikkudOptions/></div>
      <div class="mt-3 mt-lg-0 col-lg-8 px-0 px-lg-3 mx-auto">
        <div class="d-flex justify-content-between mb-2">       
          <div>
            <span v-if="hebrew" v-html="`נמצאו ${commonCount} חרוזים`"></span>
            <span v-else v-html="`${commonCount} Rhymes found`"></span>
          </div>
          <small class="more text-primary cursor-pointer" @click="switchViewOverview">
            <span v-if="hebrew" class="border-bottom border-primary">
              לכל התוצאות
            </span>
            <span v-else class="border-bottom border-primary">
              Show more
            </span>
            <i class="fas" :class ="hebrew ? 'fa-arrow-left' : 'fa-arrow-right' "></i>
          </small>
        </div>
        <div :class="{'card-body mx-n3': mobile}">          
          <div :class="{'card-text': mobile}" id="unvoc-results">  
            <ResultsList
              class="bg-white"
              :list="'common'" 
              ref="resultsList"
              @commonResults="updateCommonCount('countItems', ...arguments)"/>
          </div>
        </div>      
        <NikkudOptions v-if="!mobile"/>  
      </div>
    </div>
  </div>
</template>
<script>
  import MainSearch from '@/components/MainSearch'
  import ResultsList from '@/components/ResultsList'
  import NikkudOptions from '@/components/NikkudOptions.vue'
  export default {
  name: 'UnvocalizedScan',
  components: {MainSearch, ResultsList, NikkudOptions},
  data () {
    return {
      firstResults: [],    
      commonCount: 0  
    }
  },
  mounted () {    

  },
  methods: {
    updateCommonCount (countItems, value) {
      this.$emit('rhymeResultsCount', value)  
      this.commonCount = value
    },
    switchViewOverview () {
      const query = Object.assign({}, this.$route.query)
      this.$router.replace({ name: "home", query: query})     
      if (!this.mobile) {
        this.$store.state.displayCommon = false
        this.$store.commit('SET_OVERVIEW', true)
      }    
    },
   /*  getFirstResults() {
      this.firstResults = this.nakdanWordsArray.filter(e => e.replace(/[^א-ת]/g, '') === this.searchTerm.replace(/[^א-ת]/g, ''))
      this.displayResults()
    }, */
    
  },
  computed: {
    hebrew () {
     return this.$settings.hebrew
    },
    searchTerm () {
      return this.$store.state.soundplayCallText
    },
    charuzitSearchTerm () {
      return this.$store.state.textForCharuzitApiCall
    },    
  
    noResults () {
      return this.$store.state.noResults
    },
    mobile () {
      return this.$mq === 'xs'
    }   
  },
/*   watch: {
    nakdanWordsArrayFromState () {
      if (this.nakdanWordsArrayFromState.length > 0) {               
        this.nakdanWordsArray = this.nakdanWordsArrayFromState
        this.getFirstResults()
      }            
    }
  } */
}  
</script>
<style lang="scss">
  .unvocalized-search-wrap {
    background: #bfe1fe;
    label {
      display: none!important;
    }
  }
  .unvocalized-scan {
    width: 100%;
    overflow-x: hidden;
    .main-search {
      margin-top: 0;
    }
    @media (min-width: 992px)  {
      #common-results {
        border-radius: 6px;
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);
      }
    }
  }
  .cursor-pointer {
    cursor: pointer;
  }
  
</style>